import { FunctionComponent } from "react";
import { observer } from "mobx-react-lite";
import { Badge } from "react-bootstrap";
import ValidationSummaryViewModel, {
  ChargeRegistrationStatus,
} from "../../viewModels/paymentValidation/validationSummaryViewModel";
import * as React from "react";
import Icon, { IconType } from "@edaz/edazkit/Icon";
import ValidationCard from "./validationCard";
import RegisteredChargeResponse from "entities/registeredChargeResponse";
import Tooltip from "controls/tooltip";
import { getTimeZoneLabel } from "utils/dateUtils";
import { isMobile } from "react-device-detect";

export interface ChargeCardProps {
  charge: RegisteredChargeResponse;
  vm: ValidationSummaryViewModel;
}

const ChargeCard: FunctionComponent<ChargeCardProps> = props => {
  const { vm, charge } = props;
  const renderDateWithTimeZone = (charge: RegisteredChargeResponse) => {
    return !vm.isDifferentTimeZone ? (
      `${vm.ta("valid")} ${vm.localizationService.formatDateTime(
        new Date(charge.validSince)
      )} – ${vm.localizationService.formatDateTime(new Date(charge.validUntil))}`
    ) : (
      <>
        <span>{`${vm.ta("valid")} `}</span>
        <span>{vm.localizationService.formatDateTime(new Date(charge.validSince))}</span>
        <Tooltip
          id="cet-tooltip"
          placement={isMobile ? "bottom" : "right"}
          tooltip={vm.localizationService.translateGeneral("timezoneTooltip")}
          trigger={["hover", "focus"]}>
          <span style={{ marginLeft: 4, textDecoration: "underline", textDecorationStyle: "dotted" }}>
            {getTimeZoneLabel(new Date(charge.validSince))}
          </span>
        </Tooltip>
        <span>{" – "}</span>
        <span>{vm.localizationService.formatDateTime(new Date(charge.validUntil))}</span>
        <Tooltip
          id="cet-tooltip"
          placement={isMobile ? "bottom" : "right"}
          tooltip={vm.localizationService.translateGeneral("timezoneTooltip")}
          trigger={["hover", "focus"]}>
          <span style={{ marginLeft: 4, textDecoration: "underline", textDecorationStyle: "dotted" }}>
            {getTimeZoneLabel(new Date(charge.validUntil))}
          </span>
        </Tooltip>
      </>
    );
  };

  let iconSize = 14;
  if (window.innerWidth >= 768) {
    iconSize = 20;
  }

  let notice;
  if (charge.isCurrentlyValid) {
    notice = vm.getChargeExpiration(charge);
  } else {
    notice = vm.getChargeValidIn(charge);
  }

  const badges = (
    <>
      {vm.isChargeEco(charge) && (
        <Badge className="mr-1 mb-1 badge-lg" pill={false} variant="success-inverted">
          <Icon icon={IconType.Leaf} width={iconSize} height={iconSize} /> {vm.translate("eco")}
        </Badge>
      )}
      <Badge className="mb-1 badge-lg" pill={false} variant={charge.isCurrentlyValid ? "success-inverted" : "light"}>
        {vm.ta(charge.isCurrentlyValid ? "valid" : "future")}
      </Badge>
    </>
  );

  return (
    <ValidationCard title={vm.vehicleInfo} badges={badges}>
      {charge.isCurrentlyValid && (
        <h5 className={"mt-2 text-success font-weight-normal"}>{vm.ta(`description.${ChargeRegistrationStatus.valid}`)}</h5>
      )}
      <div>{renderDateWithTimeZone(charge)}</div>
      <div className="text-muted">{notice}</div>
    </ValidationCard>
  );
};

export default observer(ChargeCard);
